export async function apiGetLeagueLeaderboard(): Promise<{
    id: string;
    username: string;
    lapTimeReduction: number;
    remainingResources: number;
    submittedAt: string;
}[]> {
  try {
  
    const response = await fetch(process.env.REACT_APP_API_URL + `/players/leaderboard`);

    if (!response.ok) {
      const { message } = await response.json();
      throw message;
    }

    const { body } = await response.json();

    return body.leaderboard.map((submission: any) => ({
      id: submission._id,
      username: submission.username,
      lapTimeReduction: submission.lapTimeReduction,
      remainingResources: submission.remainingResources,
      submittedAt: submission.submittedAt,
    }))
  }
  catch(error) {
    throw error;
  }
}